export { FileSizeModule } from './filesize.module';
export { FileSizePipe } from './filesize.pipe';
//# sourceMappingURL=index.js.map